<template>
  <div class="chat-sidebar">
    <div
      v-for="member of others"
      :key="member.id"
    >
      <chat-user :user="member" />
    </div>
  </div>
</template>

<script>
import ChatUser from './ChatUser';

export default {
  name: 'ChatRoom',
  components: {
    ChatUser,
  },
  props: {
    user: { type: Object, required: true },
    members: { type: Array, required: true },
  },
  data() {
    return {
      error: null,
    };
  },
  computed: {
    others() {
      return this.members.filter(u => u.id !== this.user.id);
    },
  },
  methods: {
    onChatStatusUpdated(data) {
      Object.keys(data.statuses).forEach((user) => {
        const status = data.statuses[user];
        if (parseInt(user, 10) === this.userData.id) {
          if (status.status !== this.chatStatus) {
            this.changeChatStatus(this.chatStatus);
          }
        }
        this.statuses[user] = status;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-sidebar {
  width: 170px;
}
</style>
